import axios from 'axios';
import apiConfig from '../../api.config';

export default function recoverPasswordRequest({ email, lang }) {
  const {
    host,
    URIs: { auth },
  } = apiConfig;

  const uri = `${host}${auth.recoverPassword}`;

  return axios
    .post(uri, JSON.stringify({ email, lang }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
